import VisionImg from "../../assets/images/designPhases/Vision.png";
import ConceptsImg from "../../assets/images/designPhases/Concepts.png";
import RendersImg from "../../assets/images/designPhases/Renders.png";
import MaterialsImg from "../../assets/images/designPhases/Materials.png";
import DrawingsImg from "../../assets/images/designPhases/Drawings.png";

// Same phase-image matching as reno-portal's design bid review — the
// deliverable name decides which phase illustration it gets.
export const phaseImage = (name = "") => {
    const n = String(name).toLowerCase();
    if (n.includes("vision")) return VisionImg;
    if (n.includes("concept")) return ConceptsImg;
    if (n.includes("render")) return RendersImg;
    if (n.includes("material")) return MaterialsImg;
    if (n.includes("drawing")) return DrawingsImg;
    return VisionImg;
};

export const PAYMENT_STRUCTURES = [
    { value: "ONE_TIME", label: "One time payment" },
    { value: "SPLIT", label: "50/50 split" },
];

export const PAYMENT_TYPES = {
    INITIAL: "PROJECT_INITIAL_DEPOSIT",
    COMPLETION: "PROJECT_COMPLETION",
};

// Weeks between two yyyy-mm-dd dates, rounded up — powers the
// "x week(s)" pill on deliverables.
export const weeksBetween = (start, end) => {
    if (!start || !end) return null;
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (isNaN(startDate) || isNaN(endDate) || endDate < startDate) return null;
    const days = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    return Math.max(1, Math.ceil(days / 7));
};

// Normalise whatever date format the API returns ("May 31, 2026",
// ISO strings, …) into the yyyy-mm-dd a date input expects.
export const toInputDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d)) return "";
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
};
